import { useEffect, useState } from 'react';

import dayjs from 'dayjs';
import { Occurrence } from 'src/interfaces/entities/occurrence';
import { useLazyGetOccurrenceByPeriodQuery } from 'src/redux/services/centralApi';

interface IPeriod {
	inf_date: string;
	sup_date: string;
}

export const useOccurrences = () => {
	const [ getOccurrencesByPeriod, occurrencesByPeriodData, ] =
        useLazyGetOccurrenceByPeriodQuery();

	const [ period, setPeriod, ] = useState<IPeriod>({
		inf_date: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
		sup_date: dayjs().add(1, 'day').format('YYYY-MM-DD'),
	});
	const [ occurrences, setOccurrences, ] = useState<Occurrence[]>([]);
	const [ lastPeriodOccurrences, setLastPeriodOccurrences, ] = useState<
		Occurrence[]
	>([]);

	useEffect(() => {
		getOccurrences();
	}, [ period, ]);

	useEffect(() => {
		if (!occurrencesByPeriodData.data) return;

		const lastPeriod = occurrencesByPeriodData.data.filter((occurrence) =>
			dayjs(occurrence.creation_date).isBefore(period.inf_date)
		);

		const inPeriod = occurrencesByPeriodData.data.filter((occurrence) =>
			dayjs(occurrence.creation_date).isAfter(period.inf_date)
		);

		setOccurrences(inPeriod);
		setLastPeriodOccurrences(lastPeriod);
	}, [ occurrencesByPeriodData.data, ]);

	const getOccurrences = () => {
		const start_date = dayjs(period.inf_date);
		const end_date = dayjs(period.sup_date);

		const dateInterval = end_date.diff(start_date, 'day');

		const inf_date = start_date
			.subtract(dateInterval, 'day')
			.startOf('day')
			.format('YYYY-MM-DD HH:mm:ss.SSS');
		const sup_date = end_date
			.endOf('day')
			.format('YYYY-MM-DD HH:mm:ss.SSS');

		getOccurrencesByPeriod({ inf_date, sup_date, });
	};

	const setOccurrencesPeriod = (
		inf_date: dayjs.Dayjs,
		sup_date: dayjs.Dayjs
	) => {
		setPeriod({
			inf_date: inf_date.format('YYYY-MM-DD'),
			sup_date: sup_date.format('YYYY-MM-DD'),
		});
	};

	return {
		period,
		occurrences,
		lastPeriodOccurrences,
		setOccurrencesPeriod,
		isLoading: occurrencesByPeriodData.isLoading,
	};
};
